// Auto generated file, do not manually modify!
// com.hotpads.maintenancetracker.web.users.lessen.handler.MaintenanceTrackerLessenWaitlistWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { LessenWaitlistStatusResponseDto } from '../..';

export const MaintenanceTrackerLessenWaitlistWebApiHandler_join_Path = '/api/v1/users/maintenance/lessen/waitlist/join';

/**
 * Join the Lessen waitlist
 */
export const MaintenanceTrackerLessenWaitlistWebApiHandler_join = (client = getClient()) => {
  return httpFrontEndRequest<never, never, LessenWaitlistStatusResponseDto>(
    {
      endpoint: MaintenanceTrackerLessenWaitlistWebApiHandler_join_Path,
      method: 'POST',
      contextPath: '/maintenance-tracker',
    },
    client,
  );
};

export const MaintenanceTrackerLessenWaitlistWebApiHandler_status_Path =
  '/api/v1/users/maintenance/lessen/waitlist/status';

/**
 * Get the user's Lessen waitlist status
 */
export const MaintenanceTrackerLessenWaitlistWebApiHandler_status = (client = getClient()) => {
  return httpFrontEndRequest<never, never, LessenWaitlistStatusResponseDto>(
    {
      endpoint: MaintenanceTrackerLessenWaitlistWebApiHandler_status_Path,
      method: 'GET',
      contextPath: '/maintenance-tracker',
    },
    client,
  );
};
